"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var Table_1 = __importDefault(require("@material-ui/core/Table"));
var TableBody_1 = __importDefault(require("@material-ui/core/TableBody"));
var TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
var TableContainer_1 = __importDefault(require("@material-ui/core/TableContainer"));
var TableHead_1 = __importDefault(require("@material-ui/core/TableHead"));
var TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
var Paper_1 = __importDefault(require("@material-ui/core/Paper"));
var check_cell_1 = __importDefault(require("./check-cell"));
var useStyles = styles_1.makeStyles({
    table: {
        minWidth: 650
    }
});
var MatrixAssign = function (props) {
    var classes = useStyles();
    var rows = props.rows, cols = props.cols, labels = props.labels, onChange = props.onChange;
    var _a = react_1["default"].useState(props.data), data = _a[0], setData = _a[1];
    var handleClick = function (r) {
        if (r.checked) {
            var d = data.filter(function (t) { return r.x + '-' + r.y !== t.x + '-' + t.y; });
            setData(d);
        }
        else {
            data.push({ x: r.x, y: r.y });
            setData(__spreadArrays(data));
        }
        var checked = !r.checked;
        return onChange(__assign(__assign({}, r), { checked: checked }));
    };
    var topLabel = (react_1["default"].createElement(TableRow_1["default"], null,
        react_1["default"].createElement(TableCell_1["default"], null, labels === null || labels === void 0 ? void 0 : labels.vertical),
        react_1["default"].createElement(TableCell_1["default"], { align: 'center', colSpan: cols.length }, labels === null || labels === void 0 ? void 0 : labels.horizontal)));
    return (react_1["default"].createElement(TableContainer_1["default"], { component: Paper_1["default"] },
        react_1["default"].createElement(Table_1["default"], { className: classes.table, size: "small", "aria-label": "matrix assign" },
            react_1["default"].createElement(TableHead_1["default"], null,
                ((labels === null || labels === void 0 ? void 0 : labels.horizontal) || (labels === null || labels === void 0 ? void 0 : labels.vertical)) && topLabel,
                react_1["default"].createElement(TableRow_1["default"], null,
                    react_1["default"].createElement(TableCell_1["default"], null, labels === null || labels === void 0 ? void 0 : labels.corner),
                    cols.map(function (col, i) { return (react_1["default"].createElement(TableCell_1["default"], { key: i, align: 'center' }, col.label)); }))),
            react_1["default"].createElement(TableBody_1["default"], null, rows.map(function (row, j) { return (react_1["default"].createElement(TableRow_1["default"], { key: j },
                react_1["default"].createElement(TableCell_1["default"], { component: "th", scope: "row" }, row.label),
                cols.map(function (col, i) { return (react_1["default"].createElement(check_cell_1["default"], { key: i, data: data, x: col.id, y: row.id, onClick: handleClick })); }))); })))));
};
exports["default"] = MatrixAssign;
